import React, { useState, useCallback } from "react";
import { StyleSheet, View } from "react-native";
import { colors } from "src/assets";
import { useNavigation } from "@react-navigation/native";
import { Documents, Phone } from "./components";
import { RootStackScreenProps } from "src/navigation/types";

export type IdentificationNavigationParam = undefined;

enum Layout {
  Documents,
  Phone,
}

export const IdentificationScreen: React.FC = () => {
  const navigation =
    useNavigation<RootStackScreenProps<"Identification">["navigation"]>();
  const [layout, setLayout] = useState<Layout>(Layout.Documents);
  const [documents, setDocuments] = useState<Array<string>>([]);

  const documentsDoneHandler = useCallback((array: Array<string>) => {
    setDocuments(array);
    setLayout(Layout.Phone);
  }, []);

  const phoneDoneHandler = useCallback(() => {
    navigation.goBack();
  }, [navigation]);

  return (
    <View style={styles.container}>
      {layout === Layout.Documents && (
        <Documents onDone={documentsDoneHandler} />
      )}
      {layout === Layout.Phone && (
        <Phone documents={documents} onDone={phoneDoneHandler} />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
});
